<template>
  <div class="development">
    <Header @ck="onclick($event)"></Header>
    <slideshow></slideshow>
    <div class="showBusiness">
      <div class="showBusiness_box">
          <div class="showBusiness_left">
        <el-tabs :tab-position="tabPosition" v-model="activeName">
          <el-tab-pane v-for="(item, index) in arr" :key="index" :label="titlelist[index]" @tab-click="tabselect(index)" :name="index.toString()" >
            <div v-html="item.content" style='white-space: pre-wrap;' class="content_box ql-editor"></div>
            <div class="showBusiness_rigth">
              <div>
                <div class="business_bottom">
                  <ul class="business_bottom_box">
                  </ul>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
          <!-- <el-tabs :tab-position="tabPosition" style="height: 200px;">
            <el-tab-pane :label="p.title" v-for="(p,i) of arr" :key="i">
              <div v-html="p.content">{i}</div>
            </el-tab-pane>
          </el-tabs> -->
      </div>
      </div>
    
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import qs from "qs";
export default {
  name: "development",
  components: {
    Header,
    Footer,
    slideshow,
  },
  data() {
    return {
      cur: 1,
      arr: [],
      list: [],
      ast: [],
      //titlelist:["沿海运输","远洋运输","长江运输","运河运输","船员服务", "船舶管理"],
      titlelist:["沿海运输","远洋运输","长江运输","船员服务", "船舶管理"],
      tabPosition: "left",
      //获取上个页面带过来的id
      id:this.$route.query.name,
      type:this.$route.query.type,
      activeName: '0',
    };
  },
  watch:{
    activeName(){
      console.log(this.activeName,"activeName")
      // this.activeName=this.$route.query.name
      if(this.$route.query.name){
        console.log("sssssss")
         this.activeName=this.$route.query.name
      }else{
        // this.activeName="0"
      }
    }
  },
  created() {
    this.apps();
    this.list2();
  },
  mounted(){
    var id = this.$route.query.name
    console.log(id,"id")
  },
  methods: {
     onclick(data){
      console.log('123',data)
      this.activeName =data
    },
    getdata(){
      var id = this.$route.query.name
    },
    tabselect(index){ 
      console.log(index)
      console.log('1111111')
    },
    link_router() {
      this.$router.push({ path: "/Detailspage" });
    },
    apps: function () {
      this.$axios({
        method: "get",
        // url: "/index.php/show/typeshow1",
        url: "/changhang/index/list?menu=4",
      })
        .then((res) => {
          console.log('数据',res.data.rows);
          
          this.arr = res.data.rows;
          // if(this.$route.query.name){
          //   this.activeName=this.$route.query.name
          // }else{
          //   this.activeName="0"
          // }
          if(this.$route.query.name){
              this.activeName=this.$route.query.name
          }else{
              this.activeName="0" 
          }
           var id = this.$route.query.name
          
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    list2: function () {
      this.$axios({
        method: "post",
        url: "/index.php/show/showlist",
        data: qs.stringify({
          id: 2,
          pageNum: 1,
          pageSize: 7,
        }),
      })
        .then((res) => {
          this.list = res.data.data;
          //  console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
  },
};
</script>
<style scoped>
.content_box{
  margin-left: 40px;
}
.el-tabs__item{
  font-size: 24px !important;
}
.el-tabs--left .el-tabs__item.is-left{
     font-size: 24px !important;
    height: 50px !important;
}
/* .el-tabs--left, .el-tabs--left .el-tabs__item.is-left{
      font-size: 24px !important;
    height: 50px !important;
} */
.showBusiness_box{
  width: 1000px;
  margin: auto;
}
/* .content_box{
  width: 100%;
  margin: 0 auto;
} */
.imgss {
  width: 1200px;
  height: 1200px;
}
.imgss img {
  width: 100%;
  height: 100%;
}
.a {
  margin-left: 10px;
}
.business_bottom_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.business_bottom img {
  width: 100%;
}
.business_bottom_box li {
  width: 19vw;
  height: 18vw;
  margin-top: 10px;
  box-shadow: 0 0 12px 1px #ccc;
  border: 1px solid #ccc;
  z-index: 999;
}
.business_bottom_box li img {
  width: 100%;
  height: 63%;
}
.business_bottom_box li div {
  text-align: center;
  font-size: 1.2vw;
  color: #0843a1;
}
.business_bottom_box li span {
  color: #0843a1;
  /* line-height: 2; */
  width: 96%;
  margin: 0 auto;
  display: block;
  font-size: 1vw;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.showBusiness {
  /* height: 1400px; */
  /* width: 99%; */
  display: flex;
  margin-top: 1%;
  margin-bottom: 1%;
}

.management {
  position: relative;
}
.management .management_sisz {
  position: absolute;
  top: 43%;
  left: 5%;
  color: #fff;
  font-size: 2.2vw;
  margin-left: 18%;
}
.coastwise_size div {
  font-size: 16px;
  line-height: 2;
  font-weight: bold;
  margin: 3% 0;
}
.coastwise_size img {
  width: 100%;
}
.showBusiness_left {
  /* width: 95%;
  margin-left: 2%; */
  /* margin-left: 30px; */
}

.showBusiness_rigth {
  margin-left: 3%;
}
.business {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdcdc;
  margin: 15px 0;
}
.titlebar {
  font-weight: bold;
  font-size: 20px;
  color: #31518c;
}
.Figure {
  margin-top: 20px;
  margin-bottom: 20px;
}
.slash {
  text-align: center;
  /* padding-left: 44px !important; */
  border: 1px solid #eee;
  margin: 0 0 -1px -1px;
  height: 1.9vw;
  line-height: 1.9vw;
}

.el-menu {
  border-right: none;
}
.crumbs {
  display: flex;
}
.crumbs span {
  color: #969696;
}

.el-row {
  padding-left: 5%;
}
.el-submenu .el-menu-item {
  min-width: 1px;
}
.el-breadcrumb {
  line-height: 1.5;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .showBusiness .showBusiness_box{
    width: 100%;
  }
  .content_box{
    margin-left: 20px;
    margin-right: 20px;
  }
  .el-tabs__heade{
    display: none;
  }
}
</style>
<style>
.el-tabs--left .el-tabs__item.is-left{
     font-size: 24px !important;
    height: 50px !important;
}
.aaaaaaaaa{
  color: #f00;
}
.development .el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}
.development .el-submenu .el-menu .el-submenu__title {
  background-color: #fff;
  color: #000;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  line-height: 1.9vw;
  height: 1.9vw;
  padding-left: 17px !important;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background: #fff;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .development .el-tabs--left .el-tabs__item.is-left{
  
    display: none;
}
}


</style>


// WEBPACK FOOTER //
// src/pages/development/development.vue